// Using "IndexedDB" of the browser as offline database for storing data in offline mode

import animals from './entityActions/animals';
// 'animals' store is for saving list of animals fetched from the server to show when get offline
import syncEditAnimals from './entityActions/syncEditAnimals';
// 'syncEditAnimals' store is for saving edited animals on offline mode to sync them with the server when get online
import syncAnimals from './entityActions/syncAnimals';
// 'syncAnimals' store is for saving added animals on offline mode to sync them with the server when get online
// import breeds from './entityActions/breeds';
import farms from './entityActions/farms';
import groups from './entityActions/groups';
import files from './entityActions/files';
import monthlyMethane from './entityActions/monthlyMethane';
import weeklyMethane from './entityActions/weeklyMethane';
import events from './entityActions/events';
// 'events' store is for saving list of events fetched from the server to show when get offline
import eventMessages from './entityActions/eventMessages';
import syncEvents from './entityActions/syncEvents';
// 'syncEvents' store is for saving added animals on offline mode to sync them with the server when get online
import syncEventMessages from './entityActions/syncEventMessages';
import appData from './entityActions/appData';
import userPermissions from './entityActions/userPermissions';

const offlineDB = {
    animals,
    syncEditAnimals,
    syncAnimals,
    // breeds,
    farms,
    groups,
    files,
    monthlyMethane,
    weeklyMethane,
    events,
    eventMessages,
    syncEvents,
    syncEventMessages,
    appData,
    userPermissions
}

export default offlineDB;
